import { Button, Input, Space, TableProps } from "antd";
import { Link } from "react-router-dom";
import EditIcon from "../../../../assets/icons/EditIcon";
import OpenKPIIcon from "../../../../assets/icons/OpenKPIIcon";
import SearchIcon from "../../../../assets/icons/SearchIcon";
import ViewIcon from "../../../../assets/icons/ViewIcon";
import OpenKPILeftIcon from "../../../../assets/images/openKPI.svg";
import TopCard from "../../../../components/common/TopCard";
import CustomTable from "../../../../components/ui/CustomTable";
import { useGetAllKpiQuery } from "../../../../features/performanceManagement/performnceManagementApi";
import useError from "../../../../hooks/useError";
import useTable from "../../../../hooks/useTable";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { formatDate } from "../../../../lib/time";
import { GetExpenseResponseType } from "../../../../types";
import { GetAllKpiParams } from "../../../../types/performance";
import { countParPageSerialNumber } from "../../../../utils/number";
import { addKeyInArray } from "../../../../utils/utils";
import { planPeriodList, planTypeList } from "./OpenKPISetupCreate";

export function findPlanVal(arr: typeof planTypeList, val: string) {
  return val ? arr?.find((item) => item.value === val)?.label ?? val : "n/a";
}

export default function OpenKPISetup() {
  const {
    page,
    limit,
    handlePagination,
    handleLimit,
    keyword,
    handleSearch,
    filter,
  } = useTable<GetAllKpiParams>();
  const { isLoading, isFetching, isError, error, data } = useGetAllKpiQuery({
    params: { ...filter, search: keyword },
  });
  useError(isError, error, "KPI get fail");

  const columns: TableProps<
    GetExpenseResponseType["data"]["expenses"][0]
  >["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: "KPI Title",
      dataIndex: "kpi_title",
      render: (val) => val || "n/a",
    },
    {
      title: "Plan Period",
      dataIndex: "plan_period",
      render: (val) => findPlanVal(planPeriodList, val),
    },
    {
      title: "Plan Type",
      dataIndex: "plan_type",
      render: (val) => findPlanVal(planTypeList, val),
    },
    {
      title: "Created at",
      dataIndex: "created_at",
      render: (val) => (val ? formatDate(val) : "n/a"),
    },

    {
      title: "Action",
      dataIndex: "id",
      render: (val) => (
        <Space>
          <Link to={`/admin/kpi-setup/open-kpi-setup/view/${val}`}>
            <Button
              className="action-button"
              size="small"
              icon={<ViewIcon />}
            />
          </Link>
          <Link to={`/admin/kpi-setup/open-kpi-setup/update/${val}`}>
            <Button
              icon={<EditIcon />}
              size="small"
              className="action-button"
            />
          </Link>
        </Space>
      ),
    },
    {
      title: "Appraisal Setup",
      align: "center",
      width: 100,
      dataIndex: "id",
      render: (val) => (
        <Space>
          {/* <Button type="primary" className="sm-button !px-3">
            Re-open KPI
          </Button> */}

          <Link
            to={`/admin/kpi-setup/open-kpi-setup/open-appraisal-setup/${val}`}
          >
            <Button type="primary" className="!bg-[#001652] sm-button !px-3">
              Open Appraisal
            </Button>
          </Link>
        </Space>
      ),
    },
  ];

  return (
    <SidebarLayout title="Open KPI Setup">
      <TopCard className="p-9">
        <div className="flex items-center gap-9">
          <img
            className="w-20 h-20 object-contain"
            src={OpenKPILeftIcon}
            alt=""
          />
          <div className="flex-1">
            <p className="mb-4 text-header text-base font-medium">
              If you want to open goal setup from everyone particular
              department. <br /> click on open goal setup
            </p>
            <Link to="/admin/kpi-setup/open-kpi-setup/create">
              <Button
                className="sm-button"
                type="primary"
                icon={<OpenKPIIcon />}
              >
                Open KPI Setup
              </Button>
            </Link>
          </div>
        </div>
      </TopCard>

      <CustomTable
        loading={isLoading || isFetching}
        limit={limit}
        page={page}
        columns={columns}
        total={data?.data?.totalLength}
        dataSource={addKeyInArray(data?.data?.kpis)}
        handleLimit={handleLimit}
        handlePagination={handlePagination}
        filterSection={
          <>
            <Input
              suffix={<SearchIcon />}
              placeholder={`Search...`}
              style={{ minWidth: 180 }}
              onChange={handleSearch}
            />
            {/* <Button
              type="primary"
              className="middle-button !p-4"
              icon={<SettingIcon />}
            /> */}
          </>
        }
      />
    </SidebarLayout>
  );
}
